"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _modalRender = _interopRequireDefault(require("./modalRender"));
var _jsxRuntime = require("react/jsx-runtime");
const confirm = opts => {
  const {
    width,
    centered,
    zIndex = 1000,
    mask,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...renderProps
  } = opts;
  const baseClassName = "".concat(prefixClass, "-modal");
  let modalcurrent;
  modalcurrent = _antd.Modal.confirm({
    width,
    className: (0, _classnames.default)(className, baseClassName),
    style,
    centered,
    zIndex,
    mask,
    modalRender: () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_modalRender.default, {
      ...renderProps,
      onClose: () => {
        var _modalcurrent;
        return (_modalcurrent = modalcurrent) === null || _modalcurrent === void 0 ? void 0 : _modalcurrent.destroy();
      }
    })
  });
  return modalcurrent;
};
var _default = exports.default = confirm;